export default class Header {

    constructor($view) {
        this.$view = $view;
        this.$secondaryNav = this.$view.find('.js-secondary-nav');
        this.$openSecondaryNav = this.$view.find('.js-open-secondary-nav');
        this.$closeSecondaryNav = this.$view.find('.js-close-secondary-nav');

        this.bind();
    }

    bind() {

        this.$openSecondaryNav.on('click', (e) => {
           e.preventDefault();
           this.$secondaryNav.slideDown();
        });

        this.$closeSecondaryNav.on('click', (e) => {
            this.$secondaryNav.slideUp();
        });

    }

}